import React, { Component } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import Thumb from "../../molecules/Thumb";
import dateFormat from "dateformat";
import Country from "../../atoms/Country/index";
import ReCAPTCHA from "react-google-recaptcha";
import LegalCheckbox from "../../molecules/LegalCheckbox/index";
import ErrorBoundary from "../../molecules/ErrorBoundary/index";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
    maxWidth: "400px"
  },
  checkboxLabel2: {
    marginLeft: "-14px",
    display: "inline-flex"
  },
  checkboxError: {
    color: "red"
  },

  contentlist: {
    listStyleType: "none",
    marginLeft: 0,
    paddingLeft: theme.spacing(3)
  },
  idimages: {
    maxHeight: "300px",
    width: "100%",
    height: "auto"
  },
  wallet: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  order: {
    //marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  ethaddress: {
    fontFamily: "Courier"
  },
  actionsContainer: {
    marginTop: theme.spacing(3)
  },
  menu: {
    width: "100%"
  }
});

class ConfirmForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: null
    };
    this.direction = null;
    this.captcha = null;

    // This binding is necessary to make `this` work in the callback
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
  }
  handleClickNext(e, form) {
    e.preventDefault();
    this.direction = "next";
    if (process.env.REACT_APP_ENVIROMENT === "prod" && this.captcha)
      this.captcha.execute();
    form.submitForm();
    //this.setState({ direction: "next" },()=>console.log('done'));
  }
  handleClickBack(e, form) {
    e.preventDefault();
    this.direction = "back";
    //form.submitForm();
    this.props.back();
  }
  renderAllErrorMsgs(errors) {
    const listErrors = errors => {
      let elist = [];
      Object.keys(errors).forEach((key, index) => {
        elist.push(
          <Typography key={index} style={{ color: "red" }} gutterBottom>
            {errors[key]}
          </Typography>
        );
      });
      return elist;
    };
    return (
      <Grid container spacing={10}>
        <Grid item style={{ marginTop: "2em" }}>
          {listErrors(errors)}
        </Grid>
      </Grid>
    );
  }

  render() {
    const {
      personal_information,
      wallet,
      confirmation,
      document
    } = this.props.data;
    const investment = this.props.data.order.investment;

    const { classes } = this.props;
    return (
      <div>
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <Typography variant={"h5"}>Personal Information</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div
              style={{ borderLeft: "2px solid lightgrey", paddingLeft: "1em" }}
            >
              <Typography>
                {personal_information.full_first_name +
                  " " +
                  personal_information.full_last_name}
              </Typography>

              <Typography>{personal_information.street_address}</Typography>

              <Typography>
                {personal_information.zip +
                  " " +
                  personal_information.city +
                  ", "}
                <Country {...personal_information.country} />
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div
              style={{ borderLeft: "2px solid lightgrey", paddingLeft: "1em" }}
            >
              <Typography>
                <Country {...personal_information.nationality} />
                <span> (Nationality)</span>
              </Typography>

              <Typography>
                {dateFormat(personal_information.birthdate, "d. mmmm yyyy")}{" "}
                <span>(Date of birth)</span>{" "}
              </Typography>

              <Typography>{personal_information.email}</Typography>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Typography variant={"h5"}>
              {document.document_type} / {document.document_id}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={10}>
          <Grid item sm={4} xs={12}>
            <div
              style={{
                minHeight: "220px",

                border: "1px solid lightgrey",
                padding: "5px",
                marginBottom: "1em"
              }}
            >
              <Thumb image={document.document_images.frontside} />
            </div>
          </Grid>
          {document.document_type === "ID Card" && (
            <Grid item sm={4} xs={12}>
              <div
                style={{
                  minHeight: "220px",

                  border: "1px solid lightgrey",
                  padding: "5px",
                  marginBottom: "1em"
                }}
              >
                <Thumb image={document.document_images.backside} />
              </div>
            </Grid>
          )}
          <Grid item sm={4} xs={12}>
            <div
              style={{
                minHeight: "220px",

                border: "1px solid lightgrey",
                padding: "5px",
                marginBottom: "1em"
              }}
            >
              <Thumb image={document.document_images.selfi} />
            </div>
          </Grid>
        </Grid>
        <div className={classes.wallet}>
          <Typography variant={"h5"} gutterBottom>
            Your ERC20 Wallet&nbsp;Address
          </Typography>
          <Typography className={classes.ethaddress}>
            {wallet.wallet_address}
          </Typography>
        </div>
        {investment.Status !== "planned" && investment.sum > 0 && (
          <div className={classes.order}>
            <Typography variant={"h5"} gutterBottom>
              {investment.Status === "planned" ? "Planned Investment" : "Order"}
            </Typography>
            <Typography variant={"h5"} gutterBottom>
              {investment.display.token}&nbsp;CRWD-Token á{" "}
              {investment.display.sum}&nbsp;{investment.currency}
            </Typography>
            {investment.currency === "EUR" && (
              <Typography>
                <b>Please note:</b> Funds received to our account within 3
                business days of purchase will be processed for the amount of
                tokens listed in the original order. If funds are not received
                within 3 business days of purchase, the number of tokens
                purchased will be subject to change based on the exchange rate
                listed at 12am Vienna, Austria local time on the date the funds
                are finally received.
              </Typography>
            )}
          </div>
        )}

        <Formik
          enableReinitialize={true}
          initialValues={{
            lg04: confirmation.legal.lg04,
            lg05: confirmation.legal.lg05,
            lg06: confirmation.legal.lg06,
            captcha:
              process.env.REACT_APP_ENVIROMENT !== "prod"
                ? "REACT_APP_ENVIROMENT"
                : ""
          }}
          onSubmit={(values, actions) => {
            actions.setSubmitting(false);
            this.props.save({
              section: "confirmation",
              data: {
                legal: {
                  ...confirmation.legal,
                  lg04: values.lg04,
                  lg05: values.lg05,
                  lg06: values.lg06
                },
                captcha: values.captcha
              }
            });
            if (this.direction === "next") {
              this.props.next();
            } else if (this.direction === "back") {
              this.props.back();
            }
          }}
          validationSchema={Yup.object().shape({
            lg04: Yup.mixed().test(
              "is-checked",
              /*eslint-disable no-template-curly-in-string */
              "1st legal block needs to be agreed.",
              value => value.confirmation === true
            ),
            lg05: Yup.mixed().test(
              "is-checked",
              "2nd legal block needs to be agreed.",
              value => value.confirmation === true
            ),
            lg06: Yup.mixed().test(
              "is-checked",
              "3rd legal block needs to be agreed.",
              value => value.confirmation === true
            ),
            captcha: Yup.string().test(
              "captcha checked",
              "", //"The captcha needs to be confirmed.",
              value => true || (typeof value === "string" && value !== "")
            )
          })}
          render={props => (
            <form
              onSubmit={props.handleSubmit}
              className={classes.container}
              name="ConfirmForm"
            >
              <div>
                <LegalCheckbox
                  name="lg04"
                  context={[
                    "ico",
                    "CRWD Token terms",
                    "Privacy Policy",
                    "Distribution Agreement"
                  ]}
                  defaultState={false}
                  setFieldValue={props.setFieldValue}
                  value={props.values.lg04}
                  error={typeof props.errors.lg04 !== "undefined"}
                >
                  I hereby confirm that I have read and fully agree with the
                  &quot;
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_BASEURL_PAGE}/docs/CRWDToken_General_Terms_20191216.pdf`}
                  >
                    General Terms and Conditions of CRWDTokens and the CONDA
                    platform
                  </a>
                  &quot;, &quot;
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_BASEURL_PAGE}/privacy`}
                  >
                    Privacy Policy
                  </a>
                  &quot; and &quot;
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_BASEURL_PAGE}/docs/CRWDToken_Distribution_Agreement_%2020191216.pdf`}
                  >
                    Distribution Agreement
                  </a>
                  &quot;. I am aware of all the associated risks of
                  participation in the CRWDToken distribution and that I am
                  acquiring CRWDTokens entirely at my own risk.
                </LegalCheckbox>
                <LegalCheckbox
                  name="lg05"
                  context={["ico", "optin CRWD Token notification"]}
                  defaultState={false}
                  setFieldValue={props.setFieldValue}
                  value={props.values.lg05}
                  error={typeof props.errors.lg05 !== "undefined"}
                >
                  I permit CONDA to process my email address &lt;
                  {personal_information.email}&gt; to notify me about my
                  eligibility to purchase CRWDToken, changes made to the CRWDToken 
                  offer or for security notifications.
                </LegalCheckbox>
                <LegalCheckbox
                  name="lg06"
                  context={["ico", "not from exchange"]}
                  defaultState={false}
                  setFieldValue={props.setFieldValue}
                  value={props.values.lg06}
                  error={typeof props.errors.lg06 !== "undefined"}
                >
                  I permit CONDA to process my email address &lt;
                  {personal_information.email}&gt; for occasional email news and
                  updates about CONDA, its products &amp; services, promotions,
                  special offers and events.
                </LegalCheckbox>
              </div>
              <Grid container spacing={10}>
                <Grid item align="center">
                  <ErrorBoundary>
                    <ReCAPTCHA
                      ref={el => {
                        this.captcha = el;
                      }}
                      size="invisible"
                      sitekey="6LcDZ8kUAAAAAHtXHqYTS78d0Qn6ov3HHMa7xADA"
                      onChange={c => {
                        props.setFieldValue("captcha", c);
                        this.direction = "next";
                        props.submitForm();
                      }}
                    />
                  </ErrorBoundary>
                </Grid>
              </Grid>
              {this.renderAllErrorMsgs(props.errors)}
              <div className={classes.actionsContainer}>
                <Button
                  onClick={e => {
                    this.handleClickBack(e, props);
                  }}
                  disabled={this.props.step === 0}
                  className={classes.button}
                  type="button"
                >
                  Back
                </Button>
                <Button
                  name="accept"
                  //type="submit"
                  color="primary"
                  onClick={e => {
                    this.handleClickNext(e, props);
                  }}
                  variant="outlined"
                  className={classes.button}
                >
                  {this.props.step === this.props.maxsteps - 1
                    ? "I accept"
                    : "Next"}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

ConfirmForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ConfirmForm);
